import { DataAnalyticsService } from './../../services/data-analytics.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, OnDestroy } from '@angular/core';
import * as c3 from 'c3';
import { MatDialog } from '@angular/material/dialog';
import { DaVolumePopupViewComponent } from '../da-volume-popup-view/da-volume-popup-view.component';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
@Component({
  selector: 'app-da-volume',
  templateUrl: './da-volume.component.html',
  styleUrls: ['./da-volume.component.scss']
})
export class DaVolumeComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() factorySummary: any;
  @Input() currentDate: string;
  @Input() currrentFilter: string;
  @ViewChild('graphDiv', { static: true }) graphDiv: ElementRef;
  chart: any;
  isLoading = false;
  deliveredQuantity: Array<any> = [];
  cost: Array<any> = [];
  unit = '';
  public message = '';
  xAxisValue: Array<any> = [];
  divisionNumber = 1;
  signType = '';
  public oneDate: any;
  public monthName: any;
  currentEndWeek: any;
  emitDataList: any;
  subscription: Subscription;

  deliveredQtySubscription: Subscription;

  private level: string;
  private lineId: string;

  constructor(
    private daService: DataAnalyticsService,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // if (this.chart && this.chart.resize) {
    //   this.chart.resize({
    //     size: {
    //       height: 200,
    //       width: 370
    //     },
    //   });
    // }
    this.daService.getChatBoxStatus().subscribe(value => {
      if (this.chart) {
        const width = this.graphDiv.nativeElement.children.item(0).width.baseVal.value;
        if (value) {
          this.chart.resize({ height: 200, width: width - 80 });
        } else {
          this.chart.resize({ height: 200, width: width + 80 });
        }
      }
    });
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.subscription = this.route.queryParams.subscribe(params => {
        if (params.level && params.factory && params.level && params.level === 'factory') {
          this.level = params.level;
          this.lineId = (params.LineId) ? params.LineId : null;
          this.getDeliveredQuantity();
        }
      });
    }, 0);
  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  getDeliveredQuantity() {
    const daDate = this.getLocalStorageData('selectedDATimeFilter');
    this.isLoading = true;
    this.message = 'Loading...';
    this.unit = '-';
    const params = {
      FactoryId: this.factorySummary.factoryId,
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      ClusterId: this.factorySummary.clusterId,
      Level: this.factorySummary.level,
    };
    const selectedHourDetail = {};
    this.currentEndWeek = '';
    // const startOfMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    // const endOfMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.emitDataList = {
      appliedFilterType: daDate ? daDate.appliedFilterType : '',
      dateObj: new Date(this.factorySummary.fromDate),
      selectedHr: selectedHourDetail,
      endWeekFromSelectedDate: this.currentEndWeek,
      startQuarterMonth: null
    };
    this.oneDate = this.emitDataList.dateObj;
    this.monthName = this.oneDate.toLocaleString('en-us', { month: 'short' });

    this.deliveredQtySubscription = this.daService.getDeliveredQuantity(params)
      .subscribe(res => {
        if (res && res.length > 0) {
          const distinctUnit: string[] = res.map(resValue => resValue.deliveredQtyUnit).filter((item, i, ar) => ar.indexOf(item) === i);
          if (distinctUnit && distinctUnit.length > 1) {
            this.message = 'Multiple unit found';
            this.deliveredQuantity = [];
            this.cost = [];
            if (this.chart) {
              this.chart.destroy();
            }
            return;
          }
          this.unit = res.map(data => data.deliveredQtyUnit)[0];
          this.xAxisValue = res.map(value => value.dayOrMonth);
          this.deliveredQuantity = res.reduce((acc, item) => {
            acc.push(item.deliveredQty);
            return acc;
          }, []);
          const lowestCost = Math.min(...this.deliveredQuantity);

          if (lowestCost >= 1000000000) {
            // Billion
            this.divisionNumber = 1000000000;
            this.signType = 'B';
          } else if (lowestCost >= 1000000) {
            // Million
            this.divisionNumber = 1000000;
            this.signType = 'M';
          } else if (lowestCost >= 1000) {
            // Thousand
            this.divisionNumber = 1000;
            this.signType = 'K';
          }
          this.cost = res.reduce((acc, item) => {
            acc.push(item.costPercentage);
            return acc;
          }, []);
          this.isLoading = false;
          this.drawGraph();
        } else {
          this.message = 'Data not available.';
          this.deliveredQuantity = [];
          this.cost = [];
          if (this.chart) {
            this.chart.destroy();
          }
        }
      });
  }

  drawGraph() {
    const thisObj = this;
    this.chart = c3.generate({
      bindto: document.getElementById('graphDiv1'),
      // size: {
      //   height: 200,
      //   width: 370
      // },
      data: {
        x: 'x',
        columns: [
          ['x', ...this.xAxisValue],
          ['Sum of delivered Qty', ...this.deliveredQuantity],
          ['cost', ...this.cost]
        ],
        axes: {
          cost: 'y2'
        },
        types: {
          'Sum of delivered Qty': 'bar'
        },
        colors: {
          'Sum of delivered Qty': '#BF2A6E',
          cost: '#515CB4'
        },
        names: {
          cost: 'Cost %'
        }
      },
      point: {
        show: false
      },
      axis: {
        y2: {
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          tick: {
            format(x) { return x + '%'; }
          },
          show: true,
        },
        y: {
          label: {
            text: 'Delivered Quantity',
            position: 'outer-middle'
          },
          tick: {
            format(x) { return x / thisObj.divisionNumber + thisObj.signType; }
          },
          show: true,
        },
        x: {
          label: {
            text: ((this.emitDataList &&
              (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year'))
              ? 'Month' : 'Date'),
            position: 'outer-center'
          },
        }
      },
      tooltip: {
        show: true,
        format: {
          title: (x: number) => (this.emitDataList &&
            (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year')
            ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
          value: (x: number) => x > 100 ? (x / thisObj.divisionNumber).toFixed(2) + thisObj.signType : x.toFixed(2) + '%'
        }
      },
      bar: {
        width: 5
      }
    });
  }

  onChangeDate(start, end) {
    this.factorySummary.fromDate = start;
    this.factorySummary.toDate = end;
    this.getDeliveredQuantity();
  }

  showGraphInPopup() {
    this.dialog.open(DaVolumePopupViewComponent, {
      panelClass: 'popup-dialog-container',
      data: {
        divisionNumber: this.divisionNumber,
        signType: this.signType,
        xAxis: this.xAxisValue,
        deliveredQty: this.deliveredQuantity,
        cost: this.cost,
        unit: this.unit
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.deliveredQtySubscription) {
      this.deliveredQtySubscription.unsubscribe();
    }
  }

}
